import React, { useEffect, useState } from 'react';
import Dropdown from '../../Assets/Dropdown';

const SportBettingData = (props) => {
    const [totals, setTotals] = useState([]);
    const [spread, setSpread] = useState([]);
    const [moneyline, setMoneyline] = useState([]);
    const [selected, setSelected] = useState("totals");

    // Format odds to add + sign for positive values
    const formatOdds = (odds) => {
        return odds > 0 ? `+${odds}` : `${odds}`;
    };

    // run when game prop is set 
    useEffect(()=>{
        if(typeof props.game === 'object'){
            // loop through each set of odds, filter out any empty arrays, return most recent bet for each book
            if('totals' in props.game){
                let tmpTotals = [];
                for(const sb of props.game.totals){
                    // only include books that have lines
                    if(sb.lines.length > 0){
                        const pts = sb.lines[0].pts;
                        const over = sb.lines[0].over;
                        const under = sb.lines[0].under;
                        tmpTotals.push({book:sb.book, over: over, under: under, pts: pts});
                    };
                };
                setTotals(tmpTotals);
            };

            if('spread' in props.game){
                let tmpSpread = [];
                for(const sb of props.game.spread){
                    // only include books that have lines
                    if(sb.lines.length > 0){
                        let away_pts_str, home_pts_str = '';
                        const away_pts = sb.lines[0].away.pts;
                        if(away_pts > 0){
                            away_pts_str = `+${away_pts}`
                        }else away_pts_str = String(away_pts);
                        const away = {pts: away_pts_str, odds: sb.lines[0].away.odds};
    
                        const home_pts = sb.lines[0].home.pts;
                        if(home_pts > 0){
                            home_pts_str = `+${home_pts}`
                        }else home_pts_str = String(home_pts);
                        const home = {pts: home_pts_str, odds: sb.lines[0].home.odds};
    
                        tmpSpread.push({book:sb.book, home: home, away: away});
                    };
                };
                setSpread(tmpSpread);
            };

            if('ml' in props.game){
                let tmpML = [];
                for(const sb of props.game.ml){
                    // only include books that have lines
                    if(sb.lines.length > 0){
                        const away = sb.lines[0].away;
                        const home = sb.lines[0].home;
                        tmpML.push({book:sb.book, home: home, away: away});
                    };
                };
                setMoneyline(tmpML);
            };
        };
    },[props.game]);

    return (
        <div className="w-full max-w-sm">
            <div className="flex items-center justify-between mb-4 relative z-20 mt-1">
                <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">Betting Lines</h3>
                <Dropdown
                    id="bet-type-select"
                    title="Select Bet Type"
                    items={[
                        { value: 'totals', label: 'Totals' },
                        { value: 'spread', label: 'Spread' },
                        { value: 'moneyline', label: 'Moneyline' }
                    ]}
                    activeItem={selected}
                    onSelect={setSelected}
                    size="md"
                    variant="default"
                />
            </div>
            
            {selected === "totals" && (
                totals.length > 0 ? (
                    <div className="inline-block min-w-full align-middle">
                        <div className="overflow-hidden shadow ring-1 ring-gray-300 ring-opacity-5 rounded-lg dark:ring-gray-700">
                            <table className="w-full divide-y divide-gray-300 dark:divide-gray-700">
                                <thead>
                                    <tr>
                                        <th scope="col" className="border-b border-gray-300 bg-white/75 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 backdrop-blur-sm backdrop-filter dark:bg-gray-800/75 dark:border-gray-700 dark:text-gray-100 sm:pl-6">Book</th>
                                        <th scope="col" className="border-b border-gray-300 bg-white/75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur-sm backdrop-filter dark:bg-gray-800/75 dark:border-gray-700 dark:text-gray-100">Line</th>
                                        <th scope="col" className="border-b border-gray-300 bg-white/75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur-sm backdrop-filter dark:bg-gray-800/75 dark:border-gray-700 dark:text-gray-100">Over</th>
                                        <th scope="col" className="border-b border-gray-300 bg-white/75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur-sm backdrop-filter dark:bg-gray-800/75 dark:border-gray-700 dark:text-gray-100">Under</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                                    {totals.map((book) => (
                                        <tr key={book.book}>
                                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 dark:text-gray-100 sm:pl-6">{book.book}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-100">{book.pts}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-100">{formatOdds(book.over)}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-100">{formatOdds(book.under)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : (
                    <div className="text-sm text-gray-500 dark:text-gray-400 mt-4">Odds unavailable</div>
                )
            )}
            
            {selected === "moneyline" && (
                moneyline.length > 0 ? (
                    <div className="inline-block min-w-full align-middle">
                        <div className="overflow-hidden shadow ring-1 ring-gray-300 ring-opacity-5 rounded-lg dark:ring-gray-700">
                            <table className="w-full divide-y divide-gray-300 dark:divide-gray-700">
                                <thead>
                                    <tr>
                                        <th scope="col" className="border-b border-gray-300 bg-white/75 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 backdrop-blur-sm backdrop-filter dark:bg-gray-800/75 dark:border-gray-700 dark:text-gray-100 sm:pl-6">Book</th>
                                        <th scope="col" className="border-b border-gray-300 bg-white/75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur-sm backdrop-filter dark:bg-gray-800/75 dark:border-gray-700 dark:text-gray-100">Home</th>
                                        <th scope="col" className="border-b border-gray-300 bg-white/75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur-sm backdrop-filter dark:bg-gray-800/75 dark:border-gray-700 dark:text-gray-100">Away</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                                    {moneyline.map((book) => (
                                        <tr key={book.book}>
                                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 dark:text-gray-100 sm:pl-6">{book.book}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-100">{formatOdds(book.home)}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-100">{formatOdds(book.away)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : (
                    <div className="text-sm text-gray-500 dark:text-gray-400 mt-4">Odds unavailable</div>
                )
            )}
            
            {selected === "spread" && (
                spread.length > 0 ? (
                    <div className="inline-block min-w-full align-middle">
                        <div className="overflow-hidden shadow ring-1 ring-gray-300 ring-opacity-5 rounded-lg dark:ring-gray-700">
                            <table className="w-full divide-y divide-gray-300 dark:divide-gray-700">
                                <thead>
                                    <tr>
                                        <th scope="col" className="border-b border-gray-300 bg-white/75 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 backdrop-blur-sm backdrop-filter dark:bg-gray-800/75 dark:border-gray-700 dark:text-gray-100 sm:pl-6">Book</th>
                                        <th scope="col" className="border-b border-gray-300 bg-white/75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur-sm backdrop-filter dark:bg-gray-800/75 dark:border-gray-700 dark:text-gray-100">Home</th>
                                        <th scope="col" className="border-b border-gray-300 bg-white/75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur-sm backdrop-filter dark:bg-gray-800/75 dark:border-gray-700 dark:text-gray-100">Away</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                                    {spread.map((book) => (
                                        <tr key={book.book}>
                                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 dark:text-gray-100 sm:pl-6">{book.book}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-100">{`${book.home.pts} (${formatOdds(book.home.odds)})`}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-100">{`${book.away.pts} (${formatOdds(book.away.odds)})`}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : (
                    <div className="text-sm text-gray-500 dark:text-gray-400 mt-4">Odds unavailable</div>
                )
            )}
        </div>
    );
};

export default SportBettingData;